import BlockIndex from './BlockIndex';

export default BlockIndex;
